/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateFaqDto } from '../../models/create-faq-dto';
import { FaqDto } from '../../models/faq-dto';

export interface FaqControllerCreate$Params {
      body: CreateFaqDto
}

export function faqControllerCreate(http: HttpClient, rootUrl: string, params: FaqControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqDto>;
    })
  );
}

faqControllerCreate.PATH = '/api/v1/faq';
